module.exports = __webpack_public_path__ + "static/media/debian.992f49ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/debian.png
// module id = 87
// module chunks = 0